import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useStyles } from "./style";
import TopItem from "./item";
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
    paritialVisibilityGutter: 40,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 5,
    paritialVisibilityGutter: 40,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    paritialVisibilityGutter: 110,
  },
};

const sampleData = [
  {
    first: {
      img:
        "https://images.versus.io/objects/samsung-galaxy-s20-fe.front.medium.1600096664408.jpg",
      name: "Samsung Galaxy S20 FE",
    },
    second: {
      img:
        "https://images.versus.io/objects/samsung-galaxy-s10-plus.front.medium.1576684641045.jpg",
      name: "Samsung Galaxy S10 Plus",
    },
  },
  {
    first: {
      img:
        "https://images.versus.io/objects/samsung-galaxy-s20-fe.front.medium.1600096664408.jpg",
      name: "Samsung Galaxy S20 FE",
    },
    second: {
      img:
        "https://images.versus.io/objects/samsung-galaxy-s10-plus.front.medium.1576684641045.jpg",
      name: "Samsung Galaxy S10 Plus",
    },
  },
  {
    first: {
      img:
        "https://images.versus.io/objects/samsung-galaxy-s20-fe.front.medium.1600096664408.jpg",
      name: "Samsung Galaxy S20 FE",
    },
    second: {
      img:
        "https://images.versus.io/objects/samsung-galaxy-s10-plus.front.medium.1576684641045.jpg",
      name: "Samsung Galaxy S10 Plus",
    },
  },
  {
    first: {
      img:
        "https://images.versus.io/objects/samsung-galaxy-s20-fe.front.medium.1600096664408.jpg",
      name: "Samsung Galaxy S20 FE",
    },
    second: {
      img:
        "https://images.versus.io/objects/samsung-galaxy-s10-plus.front.medium.1576684641045.jpg",
      name: "Samsung Galaxy S10 Plus",
    },
  },
  {
    first: {
      img:
        "https://images.versus.io/objects/samsung-galaxy-s20-fe.front.medium.1600096664408.jpg",
      name: "Samsung Galaxy S20 FE",
    },
    second: {
      img:
        "https://images.versus.io/objects/samsung-galaxy-s10-plus.front.medium.1576684641045.jpg",
      name: "Samsung Galaxy S10 Plus",
    },
  },
  {
    first: {
      img:
        "https://images.versus.io/objects/samsung-galaxy-s20-fe.front.medium.1600096664408.jpg",
      name: "Samsung Galaxy S20 FE",
    },
    second: {
      img:
        "https://images.versus.io/objects/samsung-galaxy-s10-plus.front.medium.1576684641045.jpg",
      name: "Samsung Galaxy S10 Plus",
    },
  },
  {
    first: {
      img:
        "https://images.versus.io/objects/samsung-galaxy-s20-fe.front.medium.1600096664408.jpg",
      name: "Samsung Galaxy S20 FE",
    },
    second: {
      img:
        "https://images.versus.io/objects/samsung-galaxy-s10-plus.front.medium.1576684641045.jpg",
      name: "Samsung Galaxy S10 Plus",
    },
  },
];

const TopComparison = ({ deviceType }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <p className={classes.heading}>WHICH ARE THE MOST POPULAR COMPARISONS?</p>
      <br />
      <Carousel
        partialVisbile
        deviceType={deviceType}
        itemClass="image-item"
        responsive={responsive}
      >
        {sampleData.map((item, index) => (
          <TopItem item={item} key={index} />
        ))}
      </Carousel>
    </div>
  );
};

export default React.memo(TopComparison);
